// The community rule (PRD S5): one paragraph, linked from every page and the report sheet. Set as a
// plate (the title-page frame): the rule is a ceremonial thing, said once and kept.
import { createFileRoute } from "@tanstack/react-router";
import { Art } from "../components/Art";
import { LinkButton } from "../components/Button";
import { Plate } from "../components/Surface";
import { StaticPage, staticStyles as s } from "../components/StaticPage";
import { useTitle } from "../lib/useTitle";
import r from "./static.module.css";

export const Route = createFileRoute("/rules")({ component: Rules });

function Rules() {
  useTitle("Community rule");
  return (
    <StaticPage wide>
      <div className={r.rule}>
        <Art name="latour" treatment="duotone" shape="arch" decorative className={r.ruleArt} />
        <Plate pad="lg" className={r.plate}>
          <p className={s.cite}>Ephesians 4:15</p>
          <h1 className={s.title}>
            Speak the truth <em>in love.</em>
          </h1>
          <p className={r.ruleText}>
            Fellowship is for friends reading Scripture and the church’s writers together. Share what helps; disagree with charity; never
            abuse, harass, deceive, or post anything unlawful or sexual. Don’t present your own teaching as Bible Standard’s. We act on
            reports within a day: we may hide or remove what breaks this rule and suspend an account that keeps breaking it.
          </p>
        </Plate>
      </div>
      <dl className={`${s.terms} ${r.after}`}>
        <div>
          <dt>Reporting</dt>
          <dd>Report is in the menu of every post, comment and profile. A person looks at each report within a day.</dd>
        </div>
        <div>
          <dt>Blocking</dt>
          <dd>Someone you block can’t see you or anything you share, and isn’t told. You can unblock them in Settings.</dd>
        </div>
      </dl>
      <div className={s.actions}>
        <LinkButton to="/contact" icon="email">
          Contact us
        </LinkButton>
      </div>
    </StaticPage>
  );
}
